import { FiLoader } from 'react-icons/fi'
import styled, { keyframes } from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledTitleProps {
  theme: any
}

export const StyledTitle = styled.h2<StyledTitleProps>`
  ${({ theme }) => theme.input_label_color && `color: ${theme.input_label_color}`};
`

interface StyledFormProps {
  theme: any;
  $color: string;
}
export const StyledForm = styled.form<StyledFormProps>`
  background-color: ${({ $color, theme }) =>
    $color ? theme.lock_background_color || $color : theme.lock_background_color || '#efefef'};
  padding: ${pxToRem(40)} ${pxToRem(20)} ${pxToRem(20)} ${pxToRem(20)};
  margin: ${pxToRem(20)};
  border-radius: ${({ theme }) =>
    theme.lock_background_border_radius ? `${theme.lock_background_border_radius}px` : 0};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    ${({ theme }) => theme.lock_font && `font-family: ${theme.lock_font}`};
    margin: 0 0 ${pxToRem(20)} 0;
  }

  div {
    width: 100%;
  }
`

interface StyledLabelProps {
  theme: any;
}
export const StyledLabel = styled.label<StyledLabelProps>`
  ${({ theme }) => theme.lock_font && `font-family: ${theme.lock_font}`};
  ${({ theme }) => theme.input_label_color && `color: ${theme.input_label_color}`};
  font-weight: ${({ theme }) => theme.lock_label_weight || '400'};
  ${({ theme }) => theme.input_label_uppercase && 'text-transform: uppercase'};
`

const getImage = (error, valid) => {
  if (error) return `url('/static/svg/icon/lock.svg'), url('/static/svg/icon/error.svg')`
  if (valid) return `url('/static/svg/icon/lock.svg'), url('/static/svg/icon/valid.svg')`
  return `url('/static/svg/icon/lock.svg')`
}

const getPosition = (error, valid) => {
  if (error) return `${pxToRem(10)}, right ${pxToRem(10)} bottom ${pxToRem(10)}`
  if (valid) return `${pxToRem(10)}, right ${pxToRem(10)} bottom ${pxToRem(8)}`
  return `${pxToRem(10)}`
}

const getSize = (error, valid) => {
  if (error) return `${pxToRem(20)}, ${pxToRem(25)}`
  if (valid) return `${pxToRem(20)}, ${pxToRem(25)} ${pxToRem(28)}`
  return `${pxToRem(20)}`
}

interface StyledInputProps {
  theme: any;
  $error: boolean;
  $valid: boolean;
}
export const StyledInput = styled.input<StyledInputProps>`
  padding: ${pxToRem(10)} ${pxToRem(40)} !important;
  background-repeat: no-repeat;
  background-image: ${({ $error, $valid }) => getImage($error, $valid)};
  background-size: ${({ $error, $valid }) => getSize($error, $valid)};
  background-position: ${({ $error, $valid }) => getPosition($error, $valid)};
  margin: ${pxToRem(20)} 0 0 0;
  width: 100%;
  border: ${({ theme }) => (theme.lock_input_border_none ? 'none' : `${pxToRem(1)} solid #ccc !important`)};
  ${({ theme }) => theme.input_shadow && `box-shadow: ${theme.input_shadow}`};
`

interface StyledSmallLabelProps {
  theme: any;
  $state: string;
}
export const StyledSmallLabel = styled.p<StyledSmallLabelProps>`
  ${({ $state }) => $state === 'error' && 'color: #fe0045'};
  margin: ${pxToRem(10)};
`

const spin = keyframes`
  from {
    transform:rotate(0deg);
  }
  to {
    transform:rotate(360deg);
  }
`

export const StyledLoader = styled(FiLoader)`
  margin-right: ${pxToRem(10)};
  animation: ${spin} 3s linear infinite;
`

export const RiddleImageBefore = styled.div `
  margin: auto ${pxToRem(20)} -${pxToRem(20)} ${pxToRem(20)};
  img {
      width: 100%;
      max-height: 90px;
      object-fit: cover;
      object-position: center;
  }
`

export const RiddleImageAfter = styled.div `
  margin: -${pxToRem(20)} ${pxToRem(20)} auto ${pxToRem(20)};
  img {
      width: 100%;
      max-height: 90px;
      object-fit: cover;
      object-position: center;
  }
`

interface RiddleThumbnailImageProps {
  $borderRadius: string;
}
export const RiddleThumbnailImage = styled.div<RiddleThumbnailImageProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: -20px auto 10px auto !important;
    
  div {
      width: 125px;
      height: 125px;
      border-radius: ${({ $borderRadius }) => $borderRadius || '0'}%;
      border: 3px transparent #000;
      overflow: hidden;
      
      img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
      }
  }
`
